// 获取当前父容器的引擎数据
import { findRowIndexByUid, getRectAttribute } from "@/utils"
class GetParentEngineData {
  constructor(vue) {
    this.context = vue
  }
  init() {
    this.initData()
  }
  initData() {
    // 判断父容器是否含有tabsTiledPlugin插件
    const parentOptions = getRectAttribute.call(this.context, {
      rect_id: this.context.myid.rect_id,
      container_id: this.context.myid.container_id
    }).options
    if (parentOptions.pluginName?.includes("tabsTiledPlugin") || parentOptions.pluginName?.includes("tabsTiledHiddenPlugin")) {
      this.context.$eventBus.$on(`tabsTiledPlugin:finish`, msg => {
        this.initAllTabsDataHandle(parentOptions)
      })
    } else {
      this.initCurrentTabDataHandle(parentOptions)
    }
  }
  initAllTabsDataHandle(options) {
    const self = this
    const rowIndex = findRowIndexByUid(options, self.context.myid.uid)
    const param = {
      container_id: self.context.myid.container_id,
      rect_id: self.context.myid.rect_id,
      option_name: "activeIndex",
      option_val: rowIndex
    }
    // 这一步很关键，因为changeOptions是通过activeIndex来锁定自由布局的位置
    self.context.$store.dispatch(self.context.request_prefix + "/changeOptions", param)
    const data = self.context.shareDataPool.getData(
      `layoutData-${self.context.myid.container_id}-${self.context.myid.rect_id}-${rowIndex}`
    )

    if (data) {
      const res = JSON.parse(data)
      console.log("res", res)
      self.context.updateDataCb(res)
    }

    // 数据更新完后需要将activeIndex的值还原回去
    const deFaultParam = {
      container_id: self.context.myid.container_id,
      rect_id: self.context.myid.rect_id,
      option_name: "activeIndex",
      option_val: 0
    }
    this.context.$store.dispatch(this.context.request_prefix + "/changeOptions", deFaultParam)
  }
  initCurrentTabDataHandle(options) {
    const self = this
    const rowIndex = findRowIndexByUid(options, self.context.myid.uid)
    let data = self.context.shareDataPool.data
    Object.defineProperty(
      data,
      `layoutData-${self.context.myid.container_id}-${self.context.myid.rect_id}-${rowIndex}`,
      {
        enumerable: true,
        configurable: true,
        get: function () {
          console.log("get属性方法,当前对象：", this)
        },
        set: function (newValue) {
          const res = JSON.parse(newValue)
          self.context.updateDataCb(res)
        }
      }
    )
  }
}
export default {
  methods: {
    getParentEngineDataPlugin() {
      new GetParentEngineData(this).init()
    }
  }
}
